import React from 'react';
import { StaticQuery, graphql } from 'gatsby'
import Image from 'gatsby-image'
import { 
  Box,
  Flex,
  Container,
  Heading,
  Text,
  Link
} from '@magicsoup.io/stock'
import { 
  P,
  Footer as StyledFooter,
  MobileBox,
  Img,
  Target,
} from '../../styled'

const onPlayClickHandler = () => {
  typeof window !== "undefined" && window.gtag('event', 'clickPlayStoreLinkFooter',{
    'event_category':'engagement',
    'event_label': 'outboundStoreButton',
    'event_value': 10
  })
}

const onAppClickHandler = () => {
  typeof window !== "undefined" && window.gtag('event', 'clickAppStoreLinkFooter',{
    'event_category':'engagement',
    'event_label': 'outboundStoreButton',
    'event_value': 10
  })
}

const Footer = () => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            playStoreLink
            appStoreLink
            googleTrackingId
          }
        }
        generalJson {
          app {
            claim
          }
          footer {
            elements {
              headline
              text
            }
          }
        }
        heroJson {
          displayTitle
        }
        playStore:file(relativePath: { eq: "assets/play-store.svg" }) {
          publicURL
        }
        appStore:file(relativePath: { eq: "assets/app-store.svg" }) {
          publicURL
        }
        mobile:file(relativePath: { eq: "assets/iPhone-X-Mockup.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        footer:file(relativePath: { eq: "assets/footer.svg" }) {
          publicURL
        }
      }
    `}
    render={data => 
      <StyledFooter>
        <Container pt={5} px={3}>
          <Flex width={[1]} flexDirection="row" alignItems="center" justifyContent="center" flexWrap="wrap">
            <Box width={[1, 1/2, 1/2]}>
              <Img m={[3]} src={data.footer.publicURL} />
            </Box>

            <Flex width={[1, 1/2, 1/2]} flexDirection="column" alignItems="center">
              <Heading as="h1">{data.heroJson.displayTitle}</Heading>
              <Flex>
                <Target href={data.site.siteMetadata.appStoreLink}  target="_blank"
                  onClick={onAppClickHandler}>
                  <Img m={[3]} src={data.appStore.publicURL} />
                </Target>
                <Target href={data.site.siteMetadata.playStoreLink} target="_blank" 
                  onClick={onPlayClickHandler}>
                  <Img m={[3]} src={data.playStore.publicURL} />
                </Target>
              </Flex>
            </Flex>

            <MobileBox width={[1]} justifyContent="center" showMobile>
              <Image fluid={data.mobile.childImageSharp.fluid} />
            </MobileBox>
          </Flex>
        </Container>
        <Flex
          px={2}
          color='white'
          bg='primaryDark'
          alignItems='center'>
          <Text p={2}>
            © 2019 <a href="https://www.zauberware.com" target="_blank">zauberware technologies</a>
          </Text>
          <Box mx='auto' />
          <Link href='https://www.zauberware.com/en/imprint/' p={2} color='white' target="_blank">Imprint</Link>
          <Link href='https://www.zauberware.com/en/data-policy/' p={2} color='white' >Privacy Policy</Link>
        </Flex>
      </StyledFooter>
    }
  />
)

export default Footer